export default {
  API_BASE_URL: 'apis', //API接口地址配置    /apis/
  API_BASE_ANT: 'https://www.jf24k.com/url/', //快捷支付短连接获取接口地址
  ACCOUNT_URL: 'http://account.proway.lan/', //开户站点链接配置
  ANT_URL: 'https://third.antswallets.com/', //快捷支付PC版连接配置
  ServerIP: '[HKLive]47.52.210.28',
  // logUrl: 'https://nxcollect.mc-forex.net/bin-log',
  logUrl: '',
  FRIEND_LINK: 'https://www.jf24k.com/account/real/firendopen.html',
  BASE_LIVE800_URL: 'https://v2.live800.com/live800/chatClient/chatbox.jsp?companyID=1099118&configID=129326&jid=3399382339&operatorId=59782&s=1',
  // "https://m.prowayxau.com/chats/chatlink.html?groupid=cc66c0521509e0b5a29ecd052c036bba&fallback=1",
  BASE_DEPOSIT_URL: 'http://upay.antswallets.lan/#/pay',
}
// export default {
//   API_BASE_URL: '/apis/', //API接口地址配置    /apis/
//   API_BASE_ANT:'http://url.lan/',//快捷支付短连接获取接口地址
//   IMG_URL: 'http://192.168.0.12', //图片服务器地址配置
//   ACCOUNT_URL: 'http://account.jf24k.lan', //开户站点链接配置
//   ANT_URL: 'http://apm.magiccompass.cn:18078/', //蚂蚁钱包PC版连接配置
//   NEW_APIS: 'http://api.cms.lan/', //蚂蚁钱包PC版连接配置
//   ServerIP: '[西安测试]',
//   logUrl: 'https://nxcollect.mc-forex.net/bin-log',
//   BASE_LOGIN_URL: 'http://www.jf24k.lan/login/index.html',
//   FRIEND_LINK:'https://maccount.jf24k.com/register/realaccount.html',
//   BASE_LIVE800_URL: 'https://www.jf24k.com/common/live800.html',
// }



// WEBPACK FOOTER //
// ./src/axios/config.js